import { Component, Input } from '@angular/core';
import { ESectionCTAPosition } from '../section.interface';
import { ICustomSectionContent } from './custom-section.interface';
import { CtaComponent } from '../../cta/cta.component';
import { SafePipe } from 'src/app/core/safe/safe.pipe';

@Component({
    selector: 'app-custom-section',
    templateUrl: './custom-section.component.html',
    styleUrl: './custom-section.component.scss',
    imports: [
        SafePipe,
        CtaComponent,
    ]
})
export class CustomSectionComponent {
  @Input() public content?: ICustomSectionContent;

  public sectionCTAPosition: typeof ESectionCTAPosition = ESectionCTAPosition;
}
